import { Info } from "lucide-react";
import type React from "react";
import { Button } from "~/atoms/button";

interface Props {
  onClick?: (e: React.MouseEvent) => void;
}

export const InfoIconButton = ({ onClick }: Props) => {
  return (
    <Button onClick={onClick} variant="ghost" size="icon">
      <Info />
    </Button>
  );
};
